import apiHeader from '@/helpers/apiHeader';

const functionalLocationService = {
  list(page, params) {
    return apiHeader.get('functional-locations?page=' + page, { params });
  },
  get(id) {
    return apiHeader.get('functional-locations/' + id);
  },
};

export default functionalLocationService;
